import React from "react";

function WhyNeedAIDetector() {
  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* Title section */}
      <div>
        {/* Why do we need AI text detectors */}
        <h1 className="display-6">Why do we need AI text detectors?</h1>
      </div>

      {/* Description section */}
      <div>
        <h5 className="mt-4">Academic Integrity:</h5>
        <p className="lead">
          Detect and prevent students from using AI tools to generate essays,
          assignments, or exam answers dishonestly.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Content Authenticity:</h5>
        <p className="lead">
          Verify whether content was written by a human or AI, which is critical
          for journalism, blogs, news, and professional writing.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Preventing Misinformation:</h5>
        <p className="lead">
          AI can be used to generate large volumes of misleading or false
          content. Detection helps identify synthetic content before it spreads.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Maintaining Transparency:</h5>
        <p className="lead">
          Organizations and platforms may want to disclose when content is
          AI-generated to maintain trust with users.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Moderation and Safety:</h5>
        <p className="lead">
          AI can be used to automate spam, phishing, or harmful messages.
          Detection tools help filter or flag such content.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Intellectual Property Protection:</h5>
        <p className="lead">
          Writers and creators may want to ensure their work isn’t being
          replicated or mimicked by AI without attribution.
        </p>
      </div>

      <div>
        <h5 className="mt-4"> Hiring and Recruitment:</h5>
        <p className="lead">
          Companies may want to ensure job applicants submit original writing
          samples rather than AI-generated ones.
        </p>
      </div>
    </div>
  );
}

export default WhyNeedAIDetector;
